export default __webpack_public_path__ + "static/right-5c5c8f39c66d757af57a76e0e3fe9d94.png";